module.exports = __webpack_public_path__ + "img/arrow-paginator.0bb344b.svg";